<template>
  <div>
    <div class="toph mb16" >
      <span>待办成本报销</span>
    </div>
    <div>
      <Tabs v-model="shortCut1" class="toph-tabs">
        <TabPane :label="'水电抄表 '+ total" name="ytx"></TabPane>
      </Tabs>
      <span class="toph-tip">请于每月15号，月末28号抄送水电表数据</span>

      <table-list
        title="" :columns="columns" :data="data"
        :loading="loading" :total="total"
        :current="current" @change-page="changePage"
        :defaultTem="isShow"
        :pageSize="5"
      >
      </table-list>

      <update-modal :n="updateKey" :fid="fid" @refresh="onRefresh"></update-modal>
    </div>

  </div>
</template>

<script>
  import TableList from 'components/TableList/index'
  import { getWaterReadList, getNeedToDoNum, getMeterTypeList,  } from "api/workBench";
  import { getProjects } from 'api/common'
  import UpdateModal from "./components/UpdateModal"
  import { formatDateTime } from '@/utils/format';

  export default {
    name: "HouseRemind",
    components: {
      TableList,
      UpdateModal
    },
    mounted() {

    },
    watch:{
      projectFid(){
        this.recordCut = ''
        this.page=1
        this.current=1
        this.getpageList()
      },
      shortCut1(value) {
        this.page=1
        this.current=1
        this.getpageList();
      }
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        fid: '',
        shortCut1: 'ytx',
        sdNum: 0,
        recordCut:'',
        page: 1,
        limit: 5,
        updateKey:0,
        data:[],
        total:0,
        loading:false,
        current: 1,
        isShow:false,
        customerPhone:'',
        customerName:'',
        houseTypeFid:'',
        houseRemindFid:'',
        MeterTypeList:{},

        columns:[
          {
            type:'index',
            width:60,
          },
          {
            title:' '
          },
          {
            title: '类型',
            key: 'meterType',
            width:120,
            align: 'center',
            render: (h,params) => {
              return h('div',{
              },params.row.metertypetext);
            }
          },
          {
            title:' '
          },
          {
            title: '单价',
            key: 'price',
            width:100,
            align: 'center'
          },
          {
            title:' '
          },
          {
            title: '上期抄表日期',
            key: 'preReadTime',
            align: 'center',
            width:120,
            render(h, params){
              return h('div',{},formatDateTime(params.row.preReadTime, false))
            }
          },
          {
            title:' '
          },
          {
            title: '上期示数',
            key: 'preMeterReading',
            align: 'center',
            width:220
          },
          {
            title:' '
          },
          {
            title: '本次应抄表日期',
            key: 'scheduleDate',
            align: 'center',
            width:180,
            render(h, params){
              return h('div',{},formatDateTime(params.row.scheduleDate, false))
            }
          },
          {
            title:' '
          },
          {
            title: '操作',
            key: 'action',
            width:150,
            fixed:'right',
            align: 'center',
            render: (h,params)=>{
              return h('div',[
                h('a',{
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'waterwatt/ordinary/reading/save'
                      }
                    }
                  ],
                  style: {
                    marginRight: '5px',
                  },
                  on:{
                    click: () => {
                      this.fid = params.row.fid;
                      this.updateKey ++

                    }
                  }
                },'处理'),
            ])
            }
          },
        ],
      }
    },
    methods: {
      changePage(n) {
        this.current = n
        this.page = n
        this.getpageList()
      },
      findData(){
        this.current=1
        this.page=1
        this.getHouseRemindNum()
        this.$emit('refreshTotalNum')
      },
      getpageList() {
        if(!this.projectFid){
          return
        }
        const params={
          projectFid:this.projectFid,
          page:this.page,
          limit: 5,
        }
        getWaterReadList(params).then(res => {
          if(!res.data){
            return
          }
          this.data = res.data.rows.map(item => {
            item.metertypetext = this.MeterTypeList['metertype'+item.meterType];
            return item;
          })
          this.total = res.data.total
        }).catch(error=>{})
      },
      getMeterTypeList(){
        getMeterTypeList().then(res => {
          if(!res.data){
            return
          }
          // 先请求类型后再请求数据
          const meterType = {};
          res.data.meterType.map(item => {
            meterType['metertype'+item.value] = item.text;
          })
          this.MeterTypeList = meterType;
          this.getpageList();
        }).catch(error=>{})
      },
      // getHouseRemindNum() {
      //   if(!this.projectFid){
      //     return
      //   }
      //   let params={
      //     projectFid:this.projectFid,
      //   }
      //   getHouseRemindNum(params).then(res => {
      //     if(!res || !res.data){
      //       return
      //     }
      //     res.data.forEach((ele)=>{
      //       if(ele.businessStatus == 0){
      //         this.dtxNum = ele.number
      //       }else if (ele.businessStatus == 1){
      //         this.ytxNum = ele.number
      //       }
      //     })

      //     this.locationTab()
      //     this.getpageList()
      //   }).catch(error => {
      //   })
      // },
      clearValue() {
        this.page = 1
        this.limit = 5
      },
      onRefresh() {
        if (this.data.length === 1) {
          this.page = 1
          this.limit = 5
        }
        this.getpageList();
      },
      initData(){
        this.getMeterTypeList();
        // this.getHouseRemindNum()
      }
    },
    created() {
      this.initData()
    }
  }
</script>

<style scoped>
  .toph-tabs{
      display: inline-block;
  }
  .toph-tip{
    line-height: 38px;
    display: inline-block;
    vertical-align: top;
    color: red;
  }
  .topitem{
    width: 150px;
    text-align: center;
    line-height: 2.2;
  }
  .activeitem{
    color: #CFA868;
  }
  .itemwrapper{
    border-bottom: 1px solid #f9f9f9;

  }
  .toph{
    display: flex;
    background-color: #F4F4F4 ;
    box-shadow: 0 1px 0 0 #F4F4F4;
    justify-content: space-between;
    align-items: center;
    padding:0  20px ;
    box-sizing: border-box;
    line-height: 40px;
  }

</style>
